import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import lottie from "lottie-web";
import { Box, Flex, Stack, Title } from "@mantine/core";
import PuzzleAnimation from "../../assets/puzzle_sambla.json";
import { useStartSignIn } from "../../hooks/api/";
import { NotYetACustomer } from "../../components/notYetACustomer";
import { useUpdateCustomerPOAData } from "../../hooks/ui/customerPOADataStore";

export const Route = createFileRoute("/signin/")({
  component: SignInPage,
  beforeLoad: async () => {
    throw redirect({
      to: "/signup",
    });
  },
});

function SignInPage() {
  const {
    customerPOAData: { personalNumber, transactionId },
  } = useUpdateCustomerPOAData();
  const navigate = useNavigate();

  const startSignIn = useStartSignIn();

  useEffect(() => {
    startSignIn.mutate({ personalNumber, transactionId });
    lottie.loadAnimation({
      container: document.querySelector("#puzzle_animation") as Element,
      animationData: PuzzleAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
      name: "puzzle_animation",
    });

    return () => {
      lottie.destroy("puzzle_animation");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (startSignIn.isSuccess && startSignIn.data?.isCustomer) {
    navigate({ to: "/home" });
  }

  return (
    <>
      <Box
        id="puzzle_animation"
        h={"200px"}
        style={{ display: startSignIn.isPending ? "block" : "none" }}
      />
      {startSignIn.isPending && (
        <Flex justify={"center"} align={"center"}>
          <Stack p={"lg"} maw={"770px"} w={"100%"} h={"100vh"}>
            <Title order={2} ta="center">
              Checking user
            </Title>
          </Stack>
        </Flex>
      )}
      {startSignIn.isSuccess && !startSignIn.data?.isCustomer && (
        <NotYetACustomer />
      )}
      {startSignIn.isError && <>Error</>}
    </>
  );
}
